import React,{useEffect, useState} from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown} from "react-bootstrap";
import "./OfficeDescription.scss";
import LocRatingMap from '@Components/map/loc-rating-map';
import { MapMarkerInfoBox } from '@Components/map/map-marker';
import ReactMarkdown from "react-markdown"
import YouTube from '@u-wave/react-youtube';
import getVideoId from 'get-video-id';
import PropertyMap from "@Components/PropertyMap/PropertyMap"
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import OfficeMap from "../OfficeMap.js"
import {ImageModule} from "@Components/common/Image_Module";

const PropertyDescription = (props) => {
    
   
    const settings = {
        dots: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
             {
            breakpoint: 9999,
            settings:"unslick"
            },
        
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots:true,
            },
          },
          
        ],
      }
      const [videoId, setVideoId] = useState('');
      const [showVideo, setShowVideo] = useState(false);
      const playVideo = (Embed_Video_URL) => {  
        var videoid = getVideoId(Embed_Video_URL);
        setShowVideo(true)
        setVideoId(videoid.id)
        setShowVideomen(false)  
      setVideoIdmen('')
    }
    const closePlay = () => {
      setShowVideo(false)  
      setVideoId('')
    }
    const trackerVideo = (event) => {    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Video Play Btn',
        'formType': event,
        'formId': 'Video Play',
        'formName': 'Video',
        'formLabel': 'Video'
      });
    }

    const [videoIdmen, setVideoIdmen] = useState('');
      const [showVideomen, setShowVideomen] = useState(false);
      const playVideomen = (Embed_Video_URL) => {  
        var videoid = getVideoId(Embed_Video_URL);
        setShowVideomen(true)
        setVideoIdmen(videoid.id)
        setShowVideo(false)  
      setVideoId('')
    }
    const closePlaymen = () => {
      setShowVideomen(false)  
      setVideoIdmen('')
    }
    const trackerVideomen = (event) => {    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Video Play Btn',
        'formType': event,
        'formId': 'Video Play',
        'formName': 'Video',
        'formLabel': 'Video'
      });
    }

    // Map details
    let mapItems = [];
    let mapItem = {};
    mapItem['lat']  = props.data?.Latitude      
    mapItem['lng']  = props.data?.Longitude
    const mapMarkerImageShowFlag = 0;
    let mapItemHtml = MapMarkerInfoBox("test", mapMarkerImageShowFlag);
    // console.log( mapItemHtml );
    mapItem['html'] = mapItemHtml;
    mapItems.push( mapItem );
    // Map details
      
    let processedImages = JSON.stringify({});
                        if (props.data?.imagetransforms?.Image_Transforms) {
                            processedImages = props.data.imagetransforms.Image_Transforms;
                          }
                          let processedImages1 = JSON.stringify({});
                        if (props.data?.Choose_Person?.imagetransforms?.Image_Transforms) {
                            processedImages1 = props.data?.Choose_Person?.imagetransforms.Image_Transforms;
                          }
                          
    return (
        <React.Fragment>
            <section className="Office-description">
                <Container>
                    <div className="video-box-grid">
                        <div className="video-img-box">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <div className="video-wrap img-hover-zoom">
                            {/* <picture>
                                <source media="(min-width:992px)" srcSet={props.data?.Office_Image?.url} />
                                <source media="(min-width:768px)" srcSet={props.data?.Office_Image?.url} />
                                <img src={props.data?.Office_Image?.url} alt={props.data?.Office_Image?.alternativeText} />
                            </picture> */}
                            <ImageModule ImageSrc={props.data?.Office_Image} attr={{ alt: props.data?.Office_Image?.Name }} ggfx_results={props.data.ggfx_results} imagename="offices.Office_Image.detail" strapi_id={props.data?.id} />

                             {/* <ImageTransform imagesources={props.data?.Office_Image?.url} renderer="srcSet" imagename='offices.Office_Image.detail'
                              attr={{ alt: props.data?.Office_Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={props.data?.id} >

                            </ImageTransform> */}
                            {/* <span class="video-btn" onClick={(e) => {setPlay(true)}} ><i class="icon-video"></i></span> */}
                            
                        </div>  
                        </ScrollAnimation>      
                        </div>
                        <div className="aside-images-box">

                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        

                            <div className="team-vi-blk">
                            <div className="name-des">
                        <h4>{props.data?.Choose_Person?.Name}</h4>
                            <p>{props.data?.Choose_Person?.Designation}</p>
                            </div>
                            {showVideomen && <div onClick={(e) => {closePlaymen(e)}} className="close-iframe-btn"></div> }
                            <div className={showVideomen ? "img-hover-zoom show-video-team" : "img-hover-zoom"}>
                            {showVideomen &&
                        <YouTube
                        video={videoIdmen}
                        autoplay
                        showRelatedVideos={false}
                        showInfo={false}
                        annotations={false}
                        onEnd={e => {closePlaymen(e)}}
                        modestBranding={1}
                        onPlaying={trackerVideomen(props?.data?.Choose_Person?.Name)}

                        />
                        }
                            {/* <picture>
                                <source media="(min-width:992px)" srcSet={props.data?.Choose_Person?.Image?.url} />
                                <source media="(min-width:768px)" srcSet={props.data?.Choose_Person?.Image?.url} />
                                <img src={props.data?.Choose_Person?.Image?.url} alt={props.data?.Choose_Person?.Image?.alternativeText} />
                            </picture> */}
                            <ImageModule ImageSrc={props.data?.Choose_Person?.Image} attr={{ alt: props?.data?.Choose_Person?.Name }} ggfx_results={props.data?.Choose_Person.ggfx_results} imagename="team.Image.tail" strapi_id={props.data?.Choose_Person?.Image.id} />

                             {/* <ImageTransform imagesources={props.data?.Choose_Person?.Image?.url} renderer="srcSet" imagename='team.Image.tail'
                              attr={{ alt: props.data?.Choose_Person?.Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages1} id={props.data?.Choose_Person?.Image.id} >

                            </ImageTransform> */}
                            {props.data?.Choose_Person?.Video_Url &&
                            <span  onClick={(e) => {
                                    playVideomen(props.data?.Choose_Person?.Video_Url);
                                  }}
                                   className="video-btn"><i class="icon-video"></i></span>
                                }
                            {/* <span className="zoom-icon"><i className="icon-zoom"></i></span> */}
                            </div>
                            </div>
                        </ScrollAnimation>      
{props.data?.Latitude && props.data?.Longitude &&
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <div className="office-map">
                          <div className={"img-hover-zoom show-video-team"}>
                          <ImageModule ImageSrc={props.data?.Choose_Person?.Image} attr={{ alt: props?.data?.Choose_Person?.Name }} ggfx_results={props.data?.Choose_Person.ggfx_results} imagename="team.Image.tail" strapi_id={props.data?.Choose_Person?.Image.id} />

                          {/* <ImageTransform imagesources={props.data?.Choose_Person?.Image?.url} renderer="srcSet" imagename='team.Image.tail'
                              attr={{ alt: props.data?.Choose_Person?.Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages1} id={props.data?.Choose_Person?.Image.id} >

                            </ImageTransform> */}
                            
                           <PropertyMap className="office-map"
                        property_map_lat={props.data?.Latitude}
                        property_map_lng={props.data?.Longitude}
                    /></div></div>
                        </ScrollAnimation>      
}
                        </div>
                    </div>
                    
                    <div className="Office-description-content">
                        <div className="Office-description-col-1">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="content">
                            <ReactMarkdown source={props?.data?.Content} allowDangerousHtml />
                            </div>
                        </ScrollAnimation>      
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="local-life">
                            <Row> 
                            <Col className="column-video" md={3} xl={3}>       
                            <div className="video-small-Office-description">
                            {showVideo && <div onClick={(e) => {closePlay(e)}} className="close-iframe-btn"></div> }
                                <div className={showVideo ? "video-wrap img-hover-zoom open-video" : "video-wrap img-hover-zoom"}>
                                {showVideo &&
                        <YouTube
                        video={videoId}
                        autoplay
                        showRelatedVideos={false}
                        showInfo={false}
                        annotations={false}
                        onEnd={e => {closePlay(e)}}
                        modestBranding={1}
                        onPlaying={trackerVideo(props?.data?.Office_Name)}

                        />
                        }
                                    {/* <picture>
                                        <source media="(min-width:992px)" srcSet={props?.data?.Local_Life_Image?.url} />
                                        <source media="(min-width:768px)" srcSet={props?.data?.Local_Life_Image?.url} />
                                        <img src={props?.data?.Local_Life_Image?.url} alt={props?.data?.Local_Life_Image?.alternativeText} />
                                    </picture> */}
                                    <ImageModule ImageSrc={props.data?.Local_Life_Image} attr={{ alt: props?.data?.Office_Name }} ggfx_results={props.data.ggfx_results} imagename="offices.Local_Life_Image.tail" strapi_id={props.data?.id} />

                                    {/* <ImageTransform imagesources={props.data?.Local_Life_Image?.url} renderer="srcSet" imagename='offices.Local_Life_Image.tail'
                              attr={{ alt: props.data?.Local_Life_Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={props.data?.id} >

                            </ImageTransform> */}
                                </div>
                                {props.data?.Local_Life_Video_Url &&
                                <span class={showVideo ? "video-btn clo" : "video-btn"}  onClick={(e) => {
                                    playVideo(props.data?.Local_Life_Video_Url);
                                  }}><i class="icon-video"></i></span> 
                                }
                            </div>
                            </Col>
                            <Col className="column-text" md={9} xl={9}>
                            <div className="local-life-text-content">
                                <h3>{props?.data?.Local_Life_Title}</h3>
                                <ReactMarkdown source={props?.data?.Local_Life_Content} allowDangerousHtml />
                                {/* <p className="text-light1">Picturesque, friendly and peaceful - these are a few words to describe the beautiful Buckinghamshire landscape warranted by its title as the most filmed county in England. Whilst it has provided cinematic backdrops for the likes of Midsomer Murders, a very real community and attainable...<Link className="read-more btn-text-link">Read More</Link></p> */}
                            </div>
                            </Col>
                            </Row>
                            </div>
                        </ScrollAnimation>      

                            
                        </div>
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <div className="Office-description-col-2 keyfeatures">
                            <h2>Opening Hours</h2>
                            <table>
                                {props.data?.Add_Office_Hours?.map(list => (
                                <tr>
                                    <td>{list.Day}</td>
                                    <td>{list.Time}</td>
                                </tr>
                                 ))
                                }
                            </table>
                        </div>
                        </ScrollAnimation>
                    </div>
                    
                </Container>
                
            </section>
            <section className="map-section">
            {/* <LocRatingMap data={mapItems} /> */}
            <OfficeMap Latitude ={props.data?.Latitude} Longitude={props.data?.Longitude}  />
            </section>
        </React.Fragment>
    )
}

export default PropertyDescription;